/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';
import { PRIVATE_PATH } from '../../../constants';
import AgencyProfessionalsEmployeeDetails from './AgencyProfessionalsEmployeeDetails';
import SidebarWrapper from '../../../sections/SidebarWrapper';
import { PencilIcon } from '../../../components/icons';
import AgencyProfessionalsEditEmployee from './AgencyProfessionalsEditEmployee';
import AgencyProfessionalsCredentials from '../agency-professionals-credentials/AgencyProfessionalsCredentials';
import { useAgencyProfessionalQuery } from '../../../redux/external-agency';

const AgencyProfessionalsDetails = (props) => {
	const [editMode, setEditMode] = useState(false);
	const [showEditIcon, setShowEditIcon] = useState(false);
	const { pathname } = useLocation();
	const history = useHistory();
	const professionalId = props.match.params.caregiverId;

	const { data: professional } = useAgencyProfessionalQuery(professionalId, {
		refetchOnMountOrArgChange: true
	});

	useEffect(() => {
		if (pathname === `${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}`) {
			history.replace(`${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}/employee-details`);
		}
	}, [pathname, history, professionalId]);

	const sidebarItems = [
		{
			label: 'Employee Details',
			editTitle: 'Edit Details',
			isEditing: editMode,
			path: `${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}/employee-details`,
			additionalAction: showEditIcon && !editMode && (
				<button className="edit-contact" onClick={() => setEditMode(true)} type="button">
					<PencilIcon />
					Edit
				</button>
			),
			editText: 'Edit Details',
			className: 'details-header'
		},
		{
			label: 'Credentials',
			editTitle: professional
				? `Credentials - ${professional?.first_name || ''} ${professional?.last_name || ''}`
				: 'Credentials',
			isEditing: true,
			path: `${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}/credentials`,
			className: 'credentials-header'
		}
	];

	const handleBackToProfessionalsList = () => {
		history.push('/private/agency/professionals');
	};

	return (
		<SidebarWrapper
			sidebarTitle="Manage Professional"
			sidebarItems={sidebarItems}
			backTitle="Back To Professionals"
			backAction={handleBackToProfessionalsList}
		>
			<Switch>
				<Route path={`${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}/employee-details`}>
					{editMode ? (
						<AgencyProfessionalsEditEmployee setEditMode={setEditMode} caregiverId={professionalId} />
					) : (
						<AgencyProfessionalsEmployeeDetails setShowEditIcon={setShowEditIcon} caregiverId={professionalId} />
					)}
				</Route>
				<Route path={`${PRIVATE_PATH.PROFESSIONALS_PAGE}/${professionalId}/credentials`}>
					<AgencyProfessionalsCredentials caregiverId={professionalId} />
				</Route>
				<Route path="/*" render={() => <Redirect to="/404" />} />
			</Switch>
		</SidebarWrapper>
	);
};

export default AgencyProfessionalsDetails;
